// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-portlet .m-portlet__head .m-portlet__head-tools .new-user > .btn {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
